import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useZoomStore } from '@/shared/store/zoomStore';
import { resolveFavoriteContext } from '@/features/favorites/resolveFavoriteContext';
import { useRecentsStore } from './useRecentsStore';

// Mounted once in AppLayout. When the current route is a record detail page
// (per Favorites' resolver) and its crumb label is set, debounce ~1s then
// record it as a recent. No per-page wiring; upsert makes re-views idempotent.
export function RecentTracker() {
  const { pathname } = useLocation();
  const currentLabel = useZoomStore((s) => s.currentLabel);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const ctx = resolveFavoriteContext(pathname, currentLabel, '');
    if (ctx.kind !== 'record' || !currentLabel || !ctx.entity_type || !ctx.entity_id) return;
    const entity_type = ctx.entity_type;
    const entity_id = ctx.entity_id;
    const label = ctx.label;
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      void useRecentsStore.getState().track({ entity_type, entity_id, label });
    }, 1000);
    return () => { if (timer.current) clearTimeout(timer.current); };
  }, [pathname, currentLabel]);

  return null;
}
